import baseSingleDepartField from '../SingleDepartField/BaseSingleDepartField'

export default{
    mixins:[baseSingleDepartField],
    data:function(){
        return {
            treeValue:[]
        }
    },
    computed:{
        selectDepartInfo:function(){
            return this.departList.filter(x=> (this.data[this.name] || []).includes(x.Id));
        },

        paneDepartInfos:function(){
            return this.departList.filter(x=>(this.treeValue || []).includes(x.Id));
        },

        valueString:function(){
            return JSON.stringify(this.data[this.name]);
        }
    },
    methods:{
        showSelectZone:function(){
            if(this.disabled || this.forceDisplay){
                return;
            }
            this.treeValue = (this.data[this.name] || []).filter(x=> true);
            if(this.reComputedOptions){
                this.changeOptions();
                this.reComputedOptions = false;
            }
            this.showState = true;
        },

        sumbit:function(){
            this.data[this.name] = this.treeValue;
            this.showState = false
        },

        deleteDepart:function(depart){
            let index = this.treeValue.findIndex(x=>x == depart.Id);
            if(index != -1){
                this.treeValue.splice(index,1)
            }
        },

        handlerValueWhenChangeOptions:function(){
            if(this.$options.localOptions.filter(x=> (this.data[this.name] || []).includes(x)).length == 0){
                this.data[this.name] = [];
            }
        }
    }
}